import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class CarService {
    constructor(private http: HttpClient) { }
    getAll(perPage:number, page:number) {
        return this.http.get<any>(`${environment.apiUrl}/car/car?perPage=${perPage}&page=${page}`)
    }
    getSchedule(perPage:number, page:number) {
        return this.http.get<any>(`${environment.apiUrl}/car/schedule?perPage=${perPage}&page=${page}&order_way=desc`)
    }
    postRequest(data:any) {
        return this.http.post<any>(`${environment.apiUrl}/car/schedule`, data)
    }
}